<template>
  <div class="appointmentCheckPage">
    <header class="header">
      <!-- 搜索条件 -->
      <Card>
        <Form>
          <Row :gutter="24">
            <Col :span="2">
              <Input type="text" v-model.trim="searchItem.name" :maxlength="50" @pressEnter="getHistoryList('search')" placeholder="姓名"/>
            </Col>
            <Col :span="3">
              <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model.trim="searchItem.dateType" allowClear placeholder="请选择日期类型">
                <Option v-for="(val) in searchItem.dateTypeList" :key="val.key" :value="val.key">{{val.value}}</Option>
              </Select>
            </Col>
            <Col :span="7">
              <RangePicker :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model.trim="searchItem.startAEndTime"></RangePicker>
            </Col>
            <Col :span="4" v-if="searchMoreFlag">
              <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model.trim="searchItem.imageCenter" allowClear placeholder="请选择来源联盟">
                <Option v-for="(val, index) in searchItem.imageCenterList" :key="index" :value="val.id">{{val.name}}</Option>
              </Select>
            </Col>
            <Col :span="4" v-if="searchMoreFlag">
              <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model.trim="searchItem.scanningState" allowClear mode="multiple" placeholder="请选择检查状态" >
                <Option v-for="(val, index) in searchItem.scanningStateList" :key="index" :value="val.key">{{val.value}}</Option>
              </Select>
            </Col>
            <Col :xs="4" :sm="4" :md="4">
              <!-- <Button @click="exportExcel()" :loading="downLoading" style="margin-right:16px;">导出</Button> -->
              <Button type="primary" @click="getHistoryList('search')">搜索</Button>
            </Col>
            <!-- <Col :span="4" v-if="searchMoreFlag">
              <Select
                :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }"
                v-model.trim="searchItem.checkItem"
                allowClear
                placeholder="请选择设备类型"
                >
                <Option v-for="(val, index) in searchItem.checkItemList" :key="index" :value="val.body_id">{{val.body_name}}</Option>
              </Select>
            </Col> -->
          </Row>
          <!-- <Row :gutter="24" class="searchRow"> -->
            <!-- <Col :span="4" v-if="searchMoreFlag">
              <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model.trim="searchItem.patientChannel" allowClear placeholder="请选择患者来源" >
                <Option v-for="(val, index) in searchItem.patientChannelList" :key="index" :value="val.key">{{val.value}}</Option>
              </Select>
            </Col> -->
            <!-- <Col :span="4" v-if="searchMoreFlag">
              <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model.trim="searchItem.scanningState" allowClear mode="multiple" placeholder="请选择检查状态" >
                <Option v-for="(val, index) in searchItem.scanningStateList" :key="index" :value="val.key">{{val.value}}</Option>
              </Select>
            </Col> -->
            <!-- <Col :span="4">
              <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model.trim="searchItem.setWorkerStatus" allowClear placeholder="请选择设置工作人状态" >
                <Option v-for="(val, index) in searchItem.setWorkerStatusList" :key="index" :value="val.key">{{val.value}}</Option>
              </Select>
            </Col> -->
            <!-- <Col :xl="12" :xxl="12" :lg="12" :xs="4" :sm="4" :md="4">
              <Button @click="exportExcel()" :loading="downLoading" style="margin-right:16px;">导出</Button>
              <Button type="primary" @click="getHistoryList('search')">搜索</Button>
            </Col> -->
          <!-- </Row> -->
          <Row class="clappseRow">
            <span @click="searchClappse">{{searchMoreFlag? '收起': '展开'}}</span>
          </Row>
        </Form>
      </Card>
    </header>
    <!-- 列表展示 -->
    <article class="content">
      <Table tableLayout="fixed" :loading="showHistoryLoad" :dataSource="historyCheckList" :columns="columns" :pagination='false' rowKey="id">
        <template slot="patientName" slot-scope="text, record">
          <span>
            <span style="display: inline-block;">{{record.patient_name}} {{record.emergency ? '(急)' : ''}}</span>
            <img src="https://webimage.tongxinyiliao.com/ris/images/printer.png" style="margin-left: 10px;" v-if="record.is_printed" />
          </span>
        </template>
        <template slot="patientChannel" slot-scope="text, record">
          <span>{{record.order_source}}</span>
        </template>
        <template slot="bodyItems" slot-scope="text, record">
          <p v-for="(val, index) in record.bodyItems" :key="index">
            {{val.alias || val.name}}{{val.count > 1 ? `*${val.count}` : ''}}
          </p>
        </template>
        <template slot="scanningState" slot-scope="text, record">
          <p>{{getScanningStateValue(record.status)}}</p>
        </template>
        <template slot="worker" slot-scope="text, record">
          <span v-if="!record.operator_set">未设置</span>
          <span v-else>已设置</span>
        </template>
        <template slot="actualCost" slot-scope="text, record">
          <span>{{record.price && record.price.toFixed(2)}}</span>
        </template>
        <template slot="additionalCost" slot-scope="text, record">
          <span>{{(+record.extraCharges).toFixed(2)}}</span>
        </template>
        <div slot="control" slot-scope="text, record">
          <div v-if="isRole('ROLE_MANAGEMENT_CENTER') && ![20].includes(record.status)">
            <Button type="primary" size="small" style="margin-right: 8px;" @click="orderComplete(record)">
              <b>完成</b>
            </Button>
          </div>
          <div v-if="record.order_source === '快诊'" style="margin-top:8px;">
            <Button v-if="[0].includes(record.status)" type="primary" size="small" style="margin-right: 8px;" @click="getOrder(record)">
              <b>接单</b>
            </Button>
            <Button v-if="[0, 10, 20, 50, 60, 70, -20].includes(record.status)" type="primary" size="small" @click="viewDetail(record)">
              <b>查看详情</b>
            </Button>
            <Button v-if="[8].includes(record.status) && record.selfRun !== 1 && !isRole('ROLE_MANAGEMENT_CENTER')" type="primary" size="small" style="margin-right: 8px;" @click="orderComplete(record)">
              <b>完成</b>
            </Button>
            <Button v-if="[5, 8].includes(record.status)" type="primary" size="small" @click="editOrder(record)">
              <b>编辑</b>
            </Button>
          </div>
        </div>
      </Table>
    </article>
    <!-- 页脚内容 -->
    <footer class="footer">
      <div class="static">
        <span style="margin-right: 16px;">检查单数: {{checkOrderTotal}},</span>
        <span style="margin-right: 16px;">折算系数: {{reducedBodyTotal}},</span>
        <span style="margin-right: 16px;">医疗费用: {{medicalCost}},</span>
        <span style="margin-right: 16px;">实际费用: {{realCostTotal}},</span>
        <span style="margin-right: 16px;">额外费用: {{additionalCostTotal}},</span>
        <span>实收: {{realIncome}}</span>
      </div>
      <div class="page">
        <Pagination
          v-model="pageNumber"
          :pageSize.sync="pageSize"
          :showQuickJumper='true'
          :total="totalRecord"
          @change="searchHistoryList"
        />
      </div>
    </footer>
    <Modal title="提示" v-model="showComplete" :confirmLoading="completeOrderLoading" width="40%" @ok="completeOrder">
      <p>确认订单已完成？</p>
    </Modal>
  </div>
</template>
<script>
import { getAllBodyItem } from '../../api/check'
import { scanningStatus } from '../../core/filter'
import { setOrderStatus } from '../../api/onlineOperation'
import { getHistoryCheck, getStaticHistory, getHistoryCheckStatistics } from '../../api/historyCheck'
import { Form, Input, DatePicker, Select, Row, Col, Button, Table, Pagination, Card, Modal } from 'ant-design-vue'
import { toast, arrayUnqiue, getSession, getReservationDate, arrToJson } from '../../libs/utils'
import { mapState } from 'vuex'
import { downLoadExcel } from '../../libs/tool'
import { fixTableHeader } from '../../libs/mixin'
export default {
  mixins: [fixTableHeader],
  components: {
    Form,
    Input,
    RangePicker: DatePicker.RangePicker,
    Select,
    Option: Select.Option,
    Row,
    Col,
    Button,
    Table, 
    Pagination,
    Card,
    Modal,
  },
  data () {
    return {
      searchItem: {
        name: '',
        checkNum: '',
        startAEndTime: [],
        imageCenter: undefined,
        imageCenterList: [],
        checkItem: [],
        checkItemList: [],
        patientChannel: '快诊',
        patientChannelList: [
          { key: '线下', value: '线下' },
          { key: '快诊', value: '快诊' },
          { key: '医院体检', value: '医院体检' },
          { key: '院内患者', value: '院内患者' },
          { key: '内部福利单', value: '内部福利单' },
          { key: '外部福利单', value: '外部福利单' },
          { key: '科研检查单', value: '科研检查单' }
        ],
        scanningState: [0, 5, 8],
        scanningStateList: [
          { key: 0, value: '待接单' },
          { key: 5, value: '待定' },
          { key: 8, value: '预约完成'},
          { key: 20, value: '已完成' },
          { key: 50, value: '已扫描' },
          { key: 60, value: '扫描中' },
          { key: 10, value: '等待叫号' },
          { key: -20, value: '已取消' }
        ],
        dateType: 1,
        dateTypeList: [
          { key: 1, value: '预约日期' },
          { key: 2, value: '完成日期' },
        ],
        setWorkerStatus: 1,
        setWorkerStatusList: [
          { key: 1, value: '全部设置' },
          { key: 2, value: '未设置' },
          { key: 3, value: '已设置' }
        ]
      },
      searchMoreFlag: true,
      pageNumber: 1,
      pageSize: 20,
      totalRecord: 0,
      historyCheckList: [],
      columns: [
        {
          title: '来源联盟',
          dataIndex: 'hospital_medical_image_center_name',
          width: 100
        },
        // {
        //   title: '设备类型',
        //   dataIndex: 'device_category_name',
        //   width: 100
        // },
        {
          title: '患者姓名',
          dataIndex: 'patientName',
          scopedSlots: { customRender: 'patientName' },
          width: 200
        },
        {
          title: '来源',
          key: 'patientChannel',
          dataIndex: 'patientChannel',
          scopedSlots: { customRender: 'patientChannel' },
          width: 150
        },
        {
          title: '疾病',
          dataIndex: 'body_item_name',
          scopedSlots: { customRender: 'body_item_name' },
          width: 300
        },
        {
          title: '患者手机号',
          dataIndex: 'patient_phone',
          scopedSlots: { customRender: 'patient_phone' },
          width: 200
        },
        // {
        //   title: '折算系数',
        //   dataIndex: 'equivalent_count',
        //   width: 100
        // },
        {
           title: '订单提交时间',
           dataIndex: 'created_date',
           width: 120
         },
        {
          title: '检查状态',
          dataIndex: 'scanningState',
          scopedSlots: { customRender: 'scanningState' },
          width: 100
        },
        // {
        //   title: '检查时间',
        //   dataIndex: 'service_operation_datetime',
        //   width: 120
        // },
        // {
        //   title: '工作人',
        //   dataIndex: 'worker',
        //   scopedSlots: { customRender: 'worker' },
        //   width: 100
        // },
        // {
        //   title: '实际费用',
        //   dataIndex: 'actualCost',
        //   scopedSlots: { customRender: 'actualCost' },
        //   width: 100
        // },
        // {
        //   title: '额外费用',
        //   dataIndex: 'additionalCost',
        //   scopedSlots: { customRender: 'additionalCost' },
        //   width: 100
        // },
        // {
        //   title: '实收总计',
        //   dataIndex: 'totalAmount',
        //   width: 100
        // },
        {
          title: '操作',
          dataIndex: 'control',
          scopedSlots: { customRender: 'control' },
          width: 280
        }
      ],
      checkOrderTotal: 0,
      reducedBodyTotal: 0,
      medicalCost: 0,
      realCostTotal: 0,
      additionalCostTotal: 0,
      realIncome: 0,
      showHistoryLoad: false,
      selectLoad: false,
      showSetWorker: false,
      checkId: null,
      showExtra: false,
      showPatientChannel: false,
      showDoctorModal: false, // 匹配快诊医生弹窗
      showOrderModal: false, // 匹配快诊订单弹窗
      showChangeFrom: false, // 修改患者来源弹窗
      changeFromVal: '', // 患者来源取值
      downLoading: false, // 导出loading
      checkOrderId: '', // 检查订单ID
      sendPatientInfo: {},
      role: null,
      disAdditionalCost: true,
      disPatientChannel: false,
      showComplete: false,
      selectItem: {},
      completeOrderLoading: false
    }
  },
  computed: {
    ...mapState({
      currentCenterId: state => state.app.currentCenterId,
      deviceList: state => state.app.devices
    })
  },
  methods: {
    // 搜索条件
    searchData () {
      let params = {}
      if (this.searchItem.imageCenter) params.medicalImageCenterId = this.searchItem.imageCenter  //影像中心
      if (this.searchItem.name) params.patientName = this.searchItem.name  //患者姓名
      if (this.searchItem.startAEndTime && this.searchItem.startAEndTime.length > 0) {  //起始时间
        if (this.searchItem.dateType === 1) {
          params.startAppointmentDate = getReservationDate(this.searchItem.startAEndTime[0]).format('YYYY-MM-DD') + ' 00:00:00'
          params.endAppointmentDate = getReservationDate(this.searchItem.startAEndTime[1]).format('YYYY-MM-DD') + ' 00:00:00'
        } else if (this.searchItem.dateType === 2) {
          params.startFinishDate = getReservationDate(this.searchItem.startAEndTime[0]).format('YYYY-MM-DD') + ' 00:00:00'
          params.endFinishDate = getReservationDate(this.searchItem.startAEndTime[1]).format('YYYY-MM-DD') + ' 00:00:00'
        }
      }
      // if (this.searchItem.checkItem) params.checkItemId = this.searchItem.checkItem  //设备类型，在专科联盟弃用
      if (this.searchItem.scanningState && this.searchItem.scanningState.length > 0) {  //检查状态
        params.orderStatus = arrToJson(this.searchItem.scanningState)
      }
      // if (this.searchItem.patientChannel) params.orderSource = this.searchItem.patientChannel  //患者来源，在专科联盟弃用
      // if (this.searchItem.checkNum) params.orderCode = this.searchItem.checkNum
      // if (this.searchItem.setWorkerStatus && this.searchItem.setWorkerStatus !== 1) params.operatorSet = this.searchItem.setWorkerStatus === 2 ? 0 : 1  //工作人状态，在专科联盟弃用
      return params
    },
    // 获取历史检查列表
    async getHistoryList (type) {
      this.showHistoryLoad = true
      if (!isNaN(type)) {
        this.pageNumber = type
      }
      let params = Object.assign(this.searchData(), {
        pageNo: this.pageNumber,
        pageSize: this.pageSize,
      })
      let data = await getHistoryCheck(params)
      if (data) {
        this.historyCheckList = data.pageList.results
        this.forReportList(data.pageList.results)
        this.overMouth(data.pageList.results)
        this.totalRecord = data.pageList.totalRecord
        this.showHistoryLoad = false
      } else {
        this.historyCheckList = []
        this.showHistoryLoad = false
      }
      let staticsData = await getHistoryCheckStatistics(params)
      if (staticsData) {
        this.checkOrderTotal = staticsData.statistics.totalOrder
        this.reducedBodyTotal = staticsData.statistics.totalEquivalentCount
        this.medicalCost = staticsData.statistics.totalPrice
        this.realCostTotal = staticsData.statistics.totalRealPrice
        this.additionalCostTotal = staticsData.statistics.totalExtraPrice
        this.realIncome = staticsData.statistics.sumAllPrice
      }
    },
    // 遍历检查列表，次月一号无法操作
    overMouth (arr) {
      arr && arr.forEach(val => {
        if (val.settlement_status === 0) {
          val.overTime = false
        } else {
          val.overTime = true
        }
      })
    },
    // 遍历检查列表 展示打印图标
    forReportList (arr) {
      if (arr && arr.length > 0) {
        arr.forEach(val => {
          val.reportList && val.reportList.forEach(key => {
            if (key.isPrinted || key.isPrinted === false) {
              val.reportId = key.reportId
              val.is_printed = true
              return
            }
          })
        })
      }
    },
    // 历史检查列表的分页
    async searchHistoryList (pageNumber) {
      await this.getHistoryList(pageNumber)
    },
    // 处理扫描状态
    getScanningStateValue (num) {
      return scanningStatus(num)
    },
    // 获取当前影像中心
    getCheckImageCenter () {
      let imageList = getSession('userAuth', 'object')
      this.searchItem.imageCenterList = imageList && imageList.centerVos || []
    },
    // 根据影像中心获取检查设备列表
    async getClassType () {
      let check = await getAllBodyItem({ pageNumber: 1, pageSize: 999999 })
      if (check) {
        let arr = []
        check.results.forEach(val => {
          if (val.id) {
            arr.push({ body_id: val.id, body_name: val.name })
          }
        })
        this.searchItem.checkItemList = arrayUnqiue(arr, 'body_name')
      }
    },
    // 判断角色
    isRole (code) {
      if (!this.role || this.role.length <= 0) return
      for (let i = 0; i < this.role.length; i++) {
        if (this.role[i].rcode === code) return true
      }
    },
    // 接单
    getOrder (record) {
      this.$router.push({path: 'addCheck', query: { checkOrderId: record.id, isReceiptSuccess: true, from: 'addKzFlag' }})
    },
    // 展示订单确认框
    orderComplete (record) {
      this.selectItem = record
      this.showComplete = true
    },
    // 确认完成接单
    async completeOrder () {
      this.completeOrderLoading = true
      let params = {
        id: this.selectItem.id,
        orderCheckOrderInfoStatusEnum: 'GO_TO_APPOINTMENT'
      }
      let data = await setOrderStatus(params)
      if (data) {
        toast({ title: '提示', type: 'success', msg: '完成接单！' })
        await this.getHistoryList()
        this.showComplete = false
        this.completeOrderLoading = false
      }
      setTimeout(() => {
        this.completeOrderLoading = false
      }, 3000)
    },
    // 查看详情
    viewDetail (data) {
      this.$router.push({ path: 'addCheck', query: { checkOrderId: data.id, isEditedOperation: true } })
    },
    // 编辑订单
    editOrder (data) {
      this.$router.push({path: 'addCheck', query: { checkOrderId: data.id, isReceiptSuccess: true, from: 'editKzFlag' }})
    },
    // 导出检查订单信息
    async exportExcel () {
      this.downLoading = true
      let params = this.searchData()
      let data = await getStaticHistory(params)
      if (!data) return toast({ title: '提示', msg: '导出数据异常，请重试' })
      downLoadExcel(data)
      this.downLoading = false
    },
    searchClappse () {
      return this.searchMoreFlag = !this.searchMoreFlag
    }
  },
  async mounted () {
    this.role = getSession('userAuth', 'object').roles || null
    await this.getHistoryList()
    await this.getCheckImageCenter()
    await this.getClassType()
    this.handleTableScroll('.content')
  }
}
</script>

<style lang="less">
@import url('../../style/index.less');
.appointmentCheckPage{
  display: flex;
  flex-direction: column;
  height: 100%;
  .header{
    margin: 10px @LeaveDistance;
    .ant-card-body{
      padding: 16px 0 !important;
    }
    .ant-form{
      .ant-row{
        margin: 0 0 0 10px !important;
        .ant-select-selection--multiple{
          margin-top: 0;
        }
        .ant-col-4{
          padding-right: @LeaveDistance;
        }
        .ant-col-5{
          padding-right: @LeaveDistance;
        }
        .ant-col-6{
          padding-right: @LeaveDistance;
        }
        .ant-col-7{
          padding-right: @LeaveDistance;
        }
        .ant-col-lg-12{
          text-align: right;
        }
      }
      .searchRow{
        .ant-col-4, .ant-col-xs-4{
          margin-top: 12px;
        }
      }
    }
    .clappseRow{
      display: none;
    }
  }
  .content{
    flex: 1;
    overflow: auto;
    padding: 0 @LeaveDistance;
    table{
      background-color: #fff;
    }
  }
  .ant-calendar-picker{
    width: 100%;
  }
  .footer{
    padding: @LeaveDistance @LeaveDistance;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  @media screen and (max-width: 992px) {
    .ant-col-lg-12{
      text-align: left !important;
    }
    .clappseRow{
      display: block !important;
      padding-top: 10px; 
      color: @primaryColor;
      text-align: center !important;
    }
    .ant-table-thead{
      tr{
        th{
          min-width: 90px;
        }
      }
    }
    .footer{
      padding: 8px 16px;
      flex-direction: column;
      align-items: flex-start;
      .static{
        display: none;
      }
    }
    .ant-col-4{
      width: 50%;
    }
    .ant-col-5{
      width: 50%;
    }
    .ant-col-6{
      width: 50%;
    }
    .ant-col-7{
      margin: 12px 0;
      width: 100%;
    }
    .ant-col-xs-4{
      width: 50%;
    }
  }
  .ant-select-selection--multiple .ant-select-selection__rendered {
    overflow: hidden;
  }
  .ant-select-selection--multiple .ant-select-selection__rendered ul {
    overflow: hidden;
  }
  .ant-select-selection--multiple .ant-select-selection__choice {
    overflow: hidden;
  }
  .ant-select-selection--multiple .ant-select-search--inline {
    float: none;
    position: absolute;
  }
  .ant-select-selection--multiple {
    margin-top: 4px;
    max-height: 32px;
    overflow: hidden;
  }
  .ant-btn{
    position: static;
  }
}
</style>